import React from "react";
import PropTypes from "prop-types";
import { Card, EmptyState } from "@opendate-app/setlist";

export default function EmptyStateCard({ icon, title, description, primaryAction, secondaryAction }) {
  return (
    <Card>
      <div className="py-5" data-testid="empty-state-card">
        <EmptyState
          showRings={false}
          icon={icon}
          title={title}
          description={description}
          primaryAction={primaryAction}
          secondaryAction={secondaryAction}
        />
      </div>
    </Card>
  );
}

const actionShape = PropTypes.shape({ label: PropTypes.node.isRequired, onClick: PropTypes.func.isRequired, icon: PropTypes.elementType });

EmptyStateCard.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  primaryAction: actionShape,
  secondaryAction: actionShape,
};
